import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Alert, CircularProgress,
} from '@mui/material';
import { executeQuery } from '../../api/connections';

const CreateSchemaDialog = ({ open, onClose, connectionId, onCreated }) => {
  const [schemaName, setSchemaName] = useState('');
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');

  const handleCreate = async () => {
    const name = schemaName.trim();
    if (!name) {
      setError('Schema name is required');
      return;
    }
    setCreating(true);
    setError('');
    try {
      await executeQuery(connectionId, `CREATE SCHEMA "${name}"`);
      onCreated?.();
      handleClose();
    } catch (err) {
      setError(err.response?.data?.detail || err.message || 'Failed to create schema');
    } finally {
      setCreating(false);
    }
  };

  const handleClose = () => {
    setSchemaName('');
    setError('');
    setCreating(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Create Schema</DialogTitle>
      <DialogContent>
        <TextField
          label="Schema Name"
          value={schemaName}
          onChange={(e) => setSchemaName(e.target.value)}
          size="small"
          fullWidth
          autoFocus
          sx={{ mt: 1 }}
          onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
        />
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleCreate}
          disabled={creating || !schemaName.trim()}
          startIcon={creating ? <CircularProgress size={16} /> : null}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateSchemaDialog;
